import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00ba45fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "collection-list" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "collection-list-title" }, [
  /*#__PURE__*/_createElementVNode("p", null, "诉讼操作记录")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListView = _resolveComponent("ListView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_ListView, {
      ref: "list-view",
      "complex-list": _ctx.mainData,
      option: _ctx.listOption
    }, null, 8, ["complex-list", "option"])
  ]))
}